import {
  //
  ADD_SHIFT,
  ADD_SHIFT_FAILURE,
  ADD_SHIFT_SUCCESS,
  //
  DELETE_SHIFT,
  DELETE_SHIFT_FAILURE,
  DELETE_SHIFT_SUCCESS,
  //
  EDIT_SHIFT,
  EDIT_SHIFT_FAILURE,
  EDIT_SHIFT_SUCCESS,
  //
  FETCH_SHIFT,
  FETCH_SHIFT_FAILURE,
  FETCH_SHIFT_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  TOGGLE_HISTORY,
  //
  GET_CLOCK_HISTORY,
  GET_CLOCK_HISTORY_SUCCESS,
  GET_CLOCK_HISTORY_FAILURE,
  TOGGLE_CLOCK_HISTORY,
} from "./constants";

// List
export const fetchShift = (payload) => ({
  type: FETCH_SHIFT,
  payload,
});
export const fetchShiftSuccess = (payload) => ({
  type: FETCH_SHIFT_SUCCESS,
  payload,
});
export const fetchShiftFailure = (payload) => ({
  type: FETCH_SHIFT_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addShift = (payload, onShiftAdd) => ({
  type: ADD_SHIFT,
  payload,
  onShiftAdd,
});
export const addShiftSuccess = (payload) => ({
  type: ADD_SHIFT_SUCCESS,
  payload,
});
export const addShiftFailure = (payload) => ({
  type: ADD_SHIFT_FAILURE,
  payload,
});
// EDIT
export const editShift = (payload, onShiftEdit) => ({
  type: EDIT_SHIFT,
  payload,
  onShiftEdit,
});
export const editShiftSuccess = (payload) => ({
  type: EDIT_SHIFT_SUCCESS,
  payload,
});
export const editShiftFailure = (payload) => ({
  type: EDIT_SHIFT_FAILURE,
  payload,
});
// DELETE
export const deleteShift = (payload, onDelete) => ({
  type: DELETE_SHIFT,
  payload,
  onDelete,
});
export const deleteShiftSuccess = (payload) => ({
  type: DELETE_SHIFT_SUCCESS,
  payload,
});
export const deleteShiftFailure = (payload) => ({
  type: DELETE_SHIFT_FAILURE,
  payload,
});

// GET HISTORY
export const getHistory = (payload) => ({
  type: GET_HISTORY,
  payload,
});
export const getHistorySuccess = (payload) => ({
  type: GET_HISTORY_SUCCESS,
  payload,
});
export const getHistoryFailure = (payload) => ({
  type: GET_HISTORY_FAILURE,
  payload,
});
export const toggleHistory = (payload) => ({
  type: TOGGLE_HISTORY,
  payload,
});

//
export const getClockHistory = (payload) => ({
  type: GET_CLOCK_HISTORY,
  payload,
});
export const getClockHistorySuccess = (payload) => ({
  type: GET_CLOCK_HISTORY_SUCCESS,
  payload,
});
export const getClockHistoryFailure = (payload) => ({
  type: GET_CLOCK_HISTORY_FAILURE,
  payload,
});
export const toggleClockHistory = (payload) => ({
  type: TOGGLE_CLOCK_HISTORY,
  payload,
});
